import { render, staticRenderFns } from "./CAppSelector.vue?vue&type=template&id=180e09a8&scoped=true&"
import script from "./CAppSelector.vue?vue&type=script&lang=js&"
export * from "./CAppSelector.vue?vue&type=script&lang=js&"
import style0 from "./CAppSelector.vue?vue&type=style&index=0&id=180e09a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e09a8",
  null
  
)

export default component.exports